import './App.css';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Contact from './pages/contact/contact';
import Error from './pages/error/error';
import Articles from './articlesFinder/articles';
import Portfolio from './pages/portfolio';
import LenisProvider from './lib/LenisProvider';
import PageLoader from './components/PageLoader';
import ScrollProgress from './components/ScrollProgress';

function App() {
  return (
    <LenisProvider>
      <PageLoader />
      <ScrollProgress />
      <Router>
        <Routes>
          <Route path="/" element={<Portfolio />} />
          <Route path="/thefinderticles" element={<Articles />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="*" element={<Error />} />
        </Routes>
      </Router>
    </LenisProvider>
  );
}

export default App;
